import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute } from '@tanstack/react-router';
import { Layout } from '../../components/layout';
export const Route = createFileRoute('/')({
    component: IndexPage
});
function IndexPage() {
    return _jsx(Layout, { children: _jsx("div", { style: {
                padding: '2rem',
                textAlign: 'center'
            }, children: _jsx("p", { children: "Invalid link. Please use the link provided by your studio." }) }) });
}
if (import.meta.hot) {
    import.meta.hot.accept(newModule => {
        if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
            newModule.Route.clone(Route);
        }
    });
}
